import { useContext } from 'react';
import { useQuery } from 'react-query';
import axios from 'axios';
import { AuthContext } from '../../Context/AuthContext';


const fetchPendingDeletes = async (token) => {
  const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/charterer/profile/pendingDeletes`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data;
};


export const usePendingDeletes = () => {
  const { token } = useContext(AuthContext);

  return useQuery(['pendingDeletes'], () => fetchPendingDeletes(token), {
    enabled: !!token,
  });
};
